import { render, staticRenderFns } from "./OrderedTableForRanking.vue?vue&type=template&id=cc54a5a6&"
import script from "./OrderedTableForRanking.vue?vue&type=script&lang=js&"
export * from "./OrderedTableForRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports